import { render, staticRenderFns } from "./StampCards.vue?vue&type=template&id=45d00e45&"
import script from "./StampCards.vue?vue&type=script&lang=js&"
export * from "./StampCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports